export const fillSelector = (recordset: any) => {
  return recordset?.data.map(({ id, name }) => {
    return {
      label: name,
      value: id,
    };
  });
};
